import { createSlice } from '@reduxjs/toolkit';
import { SLICES } from '../../constants/slices';
import { SESSION_STORAGE_KEYS } from '../../constants/sessionStorageKeys';

const authSlice = createSlice({
  name: SLICES.AUTHENTICATION,
  initialState: {
    tokenClaims: JSON.parse(sessionStorage?.getItem(SESSION_STORAGE_KEYS.TOKEN_CLAIMS) || 'null'),
    oobCode: sessionStorage?.getItem(SESSION_STORAGE_KEYS.OOB_CODE) || '',
    authDetails: {
      auth0AccessToken: sessionStorage?.getItem(SESSION_STORAGE_KEYS.AUTH0_ACCESS_TOKEN || ''),
      cspAccessToken: sessionStorage?.getItem(SESSION_STORAGE_KEYS.CSP_ACCESS_TOKEN) || '',
      partnerNumber: sessionStorage?.getItem(SESSION_STORAGE_KEYS.PARTNER_NUMBER) || '',
      contactId: sessionStorage?.getItem(SESSION_STORAGE_KEYS.CONTACT_ID) || '',
      mfaAccessToken: sessionStorage?.getItem(SESSION_STORAGE_KEYS.MFA_ACCESS_TOKEN) || '',
      isAuth0Authenticated: false,
      isCspAuthenticated: false
    }
  },
  reducers: {
    setTokenClaims: (state, action) => {
      state.tokenClaims = {
        ...state.tokenClaims,
        ...action.payload.tokenClaims
      };
      sessionStorage.setItem(SESSION_STORAGE_KEYS.TOKEN_CLAIMS, JSON.stringify(state.tokenClaims));
    },
    setOobCode: (state, action) => {
      state.oobCode = action.payload;
      sessionStorage.setItem(SESSION_STORAGE_KEYS.OOB_CODE, state.oobCode);
    },
    setAuthDetails: (state, action) => {
      state.authDetails = {
        ...state.authDetails,
        cspAccessToken: action.payload.cspAccessToken,
        partnerNumber: action.payload.partnerNumber,
        contactId: action.payload.contactId,
        auth0AccessToken: action.payload.auth0AccessToken,
        isAuth0Authenticated: action.payload.isAuth0Authenticated,
        isCspAuthenticated: action.payload.isCspAuthenticated,
        mfaAccessToken: action.payload.mfaAccessToken
      };
      sessionStorage.setItem(SESSION_STORAGE_KEYS.CSP_ACCESS_TOKEN, action.payload.cspAccessToken);
      sessionStorage.setItem(SESSION_STORAGE_KEYS.PARTNER_NUMBER, action.payload.partnerNumber);
      sessionStorage.setItem(SESSION_STORAGE_KEYS.CONTACT_ID, action.payload.contactId);
      sessionStorage.setItem(SESSION_STORAGE_KEYS.MFA_ACCESS_TOKEN, action.payload.mfaAccessToken || '');
    }
  }
});

export const { setTokenClaims, setOobCode, setAuthDetails } = authSlice.actions;
export default authSlice.reducer;
